
  // モーダル表示js
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('ContactForm');
    const modal = document.getElementById('loadingModal');
    form.addEventListener('submit', function (event) {
      event.preventDefault(); // フォーム送信を防止
      // モーダルを表示
      modal.style.display = 'flex';
      const formData = new FormData(form);
      // フェイクの非同期処理をシミュレーション
      setTimeout(() => {
        const success = true; // 成功したと仮定
        if (success) {
          // 成功時：モーダルを閉じてページ遷移
          modal.style.display = 'none';
        } else {
          // エラー時：モーダルを閉じてエラー表示
          modal.style.display = 'none';
          alert('送信に失敗しました。もう一度お試しください。');
        }
      }, 3000); // 実際の処理時間に応じて調整
    });
  });